/**
 * Centralized gradient utilities
 * Provides consistent gradient styles across the application
 */

export const GRADIENT_COLORS = {
  primary: ['#FF0080', '#FF6B00'] as const,
  pink: '#FF0080',
  orange: '#FF6B00',
} as const;

/**
 * Creates a linear gradient string for CSS
 */
export const createGradient = (colors: readonly string[], angle: number = 135): string => {
  return `linear-gradient(${angle}deg, ${colors.join(', ')})`;
};

/**
 * Primary brand gradient (pink to orange)
 */
export const primaryGradient = createGradient(GRADIENT_COLORS.primary);

/**
 * CSS style object for primary gradient text
 */
export const gradientTextStyle: React.CSSProperties = {
  background: primaryGradient,
  WebkitBackgroundClip: 'text',
  backgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
};

/**
 * CSS style object for primary gradient background
 */
export const gradientBgStyle: React.CSSProperties = {
  background: primaryGradient,
};

/**
 * Tailwind class for gradient background
 */
export const GRADIENT_CLASS = 'bg-gradient-pink';

